import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Settings2, Clock, CheckCircle, AlertCircle } from "lucide-react";

export default function BookingModificationsPage() {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="container mx-auto p-4 md:p-6 max-w-7xl">
      <div className="flex items-center gap-4 mb-8">
        <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg flex items-center justify-center shadow-lg">
          <Settings2 className="w-6 h-6 text-white" />
        </div>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">طلبات التعديل</h1>
          <p className="text-muted-foreground mt-1">
            إدارة طلبات تعديل وإلغاء الحجوزات
          </p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-4 mb-6">
        <div className="relative flex-1">
          <Input
            placeholder="البحث في طلبات التعديل..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        
        <Button>
          <Settings2 className="w-4 h-4 ml-2" />
          طلب تعديل جديد
        </Button>
      </div>

      <div className="grid gap-4">
        <Card>
          <CardHeader>
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <CardTitle className="text-lg mb-2">طلب تعديل حجز رقم #12345</CardTitle>
                <CardDescription>
                  العميل: أحمد محمد • نوع الطلب: تعديل التاريخ
                </CardDescription>
              </div>
              <div className="flex gap-2">
                <Badge className="bg-yellow-100 text-yellow-800">
                  قيد المراجعة
                </Badge>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">
              طلب تعديل تاريخ السفر من 15/01/2025 إلى 20/01/2025
            </p>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4 text-sm text-muted-foreground">
                <div className="flex items-center gap-1">
                  <Clock className="w-4 h-4" />
                  قبل يومين
                </div>
              </div>
              
              <div className="flex gap-2">
                <Button size="sm" variant="outline">
                  مراجعة
                </Button>
                <Button size="sm">
                  موافقة
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="text-center py-8 text-muted-foreground">
          لا توجد طلبات تعديل أخرى
        </div>
      </div>
    </div>
  );
}